import { createContext } from 'react';

import { RecommendationFormContextStateType } from './RecommendationFormProvider';

const defaultValue: RecommendationFormContextStateType = {
  isFormActive: false,
};

export const RecommendationFormContext = createContext<RecommendationFormContextStateType>(defaultValue);
